const domainGym = (state) => state.domainGym;

export default domainGym;
